import type { ReactNode } from 'react';

/**
 * Emphasis for keywords in headings, per Ariviti TABS: colour plus a flat 4px Vibrant Orange
 * underline. On white the word turns Royal Indigo; on Dark Indigo fields it keeps the
 * heading colour and the orange rule carries the emphasis (orange is never text on indigo).
 * No hand-drawn marks, italics or highlighter swipes. Styles live in `.mark-tabs` (globals.css).
 */
export function Mark({ children, className = '' }: { children: ReactNode; className?: string }) {
  return <mark className={`mark-tabs ${className}`.trim()}>{children}</mark>;
}
